import { createPinia } from 'pinia'
import { createStore } from 'vuex'
import state from '@/state/state'

export function setUpStore(app) {
  const store = createStore(state)
  app.use(store)
  app.use(createPinia())
}
